import {
  SET_SUGGESTED_DEPARTURE_LOCATION,
  SET_SUGGESTED_FURTHEST_DESTINATION,
  TRAVEL_DEPARTURE_SEARCH_RESULT,
  TRAVEL_DESTINATIONS_SEARCH_RESULT,
  TRAVEL_LOCATIONS,
  TRAVEL_LOCATIONS_FAILED,
  TRAVEL_LOCATIONS_SUCCESS,
  TravelDepartureDestinations,
  TravelLocations
} from './types';

export const travelLocations = (
  state: TravelDepartureDestinations = {
    retrievePending: true,
    loading: false
  },
  action: {
    type: string;
    payload?: TravelLocations[];
  }
): TravelDepartureDestinations => {
  switch (action.type) {
    case TRAVEL_DEPARTURE_SEARCH_RESULT:
      return { ...state, departure: action.payload };
    case TRAVEL_DESTINATIONS_SEARCH_RESULT:
      return { ...state, destinations: action.payload };
    case TRAVEL_LOCATIONS:
      return { ...state, retrievePending: true, loading: true };
    case TRAVEL_LOCATIONS_SUCCESS:
      return { ...state, retrievePending: false, loading: false, response: action.payload };
    case TRAVEL_LOCATIONS_FAILED:
      return { retrievePending: true, loading: false, error: action.payload };
    case SET_SUGGESTED_DEPARTURE_LOCATION:
      return { ...state, suggestedDepartureLocation: action.payload };
    case SET_SUGGESTED_FURTHEST_DESTINATION:
      return { ...state, suggestedFurthestDestination: action.payload };
    default:
      return state;
  }
};
